import ApiCaller from '../ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import { shouldFetchEntries, getAutoSuggestTTL } from 'components/Header/Search/AutoSuggestTTLUtils';
export var AUTOSUGGEST_REQUEST;
(function (AUTOSUGGEST_REQUEST) {
    AUTOSUGGEST_REQUEST["INIT"] = "AUTOSUGGEST_INIT";
    AUTOSUGGEST_REQUEST["GET_REQUEST"] = "GET_AUTOSUGGEST_REQUEST";
    AUTOSUGGEST_REQUEST["SUCCESS"] = "AUTOSUGGEST_SUCCESS";
    AUTOSUGGEST_REQUEST["ERROR"] = "GET_AUTOSUGGEST_ERROR";
    AUTOSUGGEST_REQUEST["CHANGE_QUERY"] = "CHANGE_AUTOSUGGEST_QUERY";
    AUTOSUGGEST_REQUEST["SAVE_HISTORY"] = "SAVE_HISTORY";
    AUTOSUGGEST_REQUEST["SAVE_PLAIN_QUERY_HISTORY"] = "SAVE_PLAIN_QUERY_HISTORY";
    AUTOSUGGEST_REQUEST["GET_HISTORY"] = "GET_HISTORY";
})(AUTOSUGGEST_REQUEST || (AUTOSUGGEST_REQUEST = {}));
/**
 * this is V4 proxy function for the purpose of V3 and V4 AB
 * Cleanup required when removing AB - Contact Jay
 * @param queryString user typed query
 * @param marketPlaceId marketplace where user ise searching "FLIPKART or GROCERY"
 * @param contextUriString current page url where user is using searchbar to search
 * @param searchBrowseRequestHistory user's previous search history
 */
function makeApiRequest(queryString, marketPlaceId, contextUriString, searchBrowseRequestHistory, zeroPrefixHistory) {
    return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
        pathname: '/api/4/discover/autosuggest',
        action: AUTOSUGGEST_REQUEST.GET_REQUEST,
        searchBrowseRequestHistory
    }), {
        query: queryString,
        contextUri: contextUriString,
        marketPlaceId,
        types: ['QUERY', 'QUERY_STORE', 'PRODUCT', 'RICH', 'PARTITION'],
        rows: 10,
        zeroPrefixHistory,
        userTimeStamp: Date.now(),
        searchBrowseHistory: searchBrowseRequestHistory
    });
}
function successResponse(dispatch, json, query, marketplace, responseTimeInMS) {
    return dispatch({
        type: AUTOSUGGEST_REQUEST.SUCCESS,
        data: json,
        query,
        marketplace,
        responseTimeInMS
    });
}
function fetchAutosuggestActionFactory(queryString, marketPlaceId, contextUriString, zeroPrefixHistory) {
    return (dispatch, getState) => {
        let { autosuggest, config } = getState();
        dispatch({
            type: AUTOSUGGEST_REQUEST.GET_REQUEST,
            query: queryString,
            contextUri: contextUriString,
            marketplace: marketPlaceId
        });
        if (!queryString) {
            dispatch({
                type: AUTOSUGGEST_REQUEST.GET_HISTORY,
                query: queryString,
                marketplace: marketPlaceId
            });
        }
        /** Every time api call is made succefully, response is being stored in memory
         * if user has already search for some query in the session then
         * serving directly from memory
         * instead of making api call again
         * Stored response are marketplace specific
         * Maintaining saperate copy for Flipkart and Grocery marketplace in Map
         * */
        if (shouldFetchEntries(autosuggest, queryString, marketPlaceId, getAutoSuggestTTL(config))) {
            const autosuggestHistory = autosuggest.searchBrowseRequestHistory[marketPlaceId];
            // An experiment will be run in which we will show the search history items to the
            // user from the server response. Previously they were read from local storage. We
            // will be tracking the API response times which will help us correlating other
            // metric changes with the network induced latency.
            const requestStartTime = Date.now();
            return makeApiRequest(queryString, marketPlaceId, contextUriString, autosuggestHistory, zeroPrefixHistory).then(json => {
                const requestEndTime = Date.now();
                const responseTimeInMS = requestEndTime - requestStartTime;
                return successResponse(dispatch, json, queryString, marketPlaceId, responseTimeInMS);
            }, error => {
                dispatch({
                    type: AUTOSUGGEST_REQUEST.ERROR,
                    error,
                    query: queryString,
                    marketplace: marketPlaceId
                });
            });
        }
        return dispatch({
            type: AUTOSUGGEST_REQUEST.CHANGE_QUERY,
            query: queryString,
            marketplace: marketPlaceId
        });
    };
}
export function fetchAutosuggestAction(queryString, marketPlaceId, contextUri, zeroPrefixHistory = false) {
    return fetchAutosuggestActionFactory(queryString, marketPlaceId, contextUri, zeroPrefixHistory);
}
export function saveAutosuggestItemAction(suggestionValue, marketplace) {
    return { type: AUTOSUGGEST_REQUEST.SAVE_HISTORY, data: suggestionValue, marketplace };
}
export function savePlainQueryItemAction(query, url, marketplace) {
    return { type: AUTOSUGGEST_REQUEST.SAVE_PLAIN_QUERY_HISTORY, query, marketplace, url };
}
export function initAutoSuggestAction() {
    return { type: AUTOSUGGEST_REQUEST.INIT };
}
